import { Component } from 'react';
import * as React from 'react';
import { deepEquals } from 'app/infrastructure/js';

/**
 * Higher Order Component that evaluates if `props.hostProps().activeChildItem` is the current. If so, it activates
 * scrollIntoView animation to focus the UI element for the user, and passes the prop `activate:boolean` downwards
 */
export class Activator extends Component<any, any> {
  private element: any;
  public state: Readonly<any> = {
    lastActiveChildItem: undefined
  };

  public componentDidMount() {
    this.activateIfNeeded();
  }

  private get isActive(){
    const { activeChildItem } = this.props;

    if (activeChildItem && this.props.resolveContext.path && this.props.resolveContext.path.length > 1 ) {
      const partialPath = activeChildItem.slice(0, this.props.resolveContext.path.length);
      return deepEquals(this.props.resolveContext.path, partialPath);
    }
    return false;
  }

  private get shouldActivateItself(){
    const { activeChildItem } = this.props;
    const hasChanged = !deepEquals(this.state.lastActiveChildItem, activeChildItem);
    return hasChanged && this.isActive;
  }

  public componentDidUpdate(prevProps:any) {
    if(this.props !== prevProps) {
      this.activateIfNeeded();
    }
  }

  private activateIfNeeded(){
    const { activeChildItem } = this.props;
    if (this.shouldActivateItself && this.element) {
      this.setState({lastActiveChildItem: activeChildItem});
    }
  }
  

  public addRef = (el: any) => {
    if (el) {
      this.element = el;
    }
  };

  public render() {

    // To avoid react-router instances being cloned (breaks the router), we add the existing router and history
    const { router, route, history } = this.props;

    return (
      <div ref={this.addRef}>
        {React.cloneElement(React.Children.only(this.props.children as any), {router, route, history, ...{activate: this.isActive}})}
      </div>
    );

  }
}
